import { Component } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ContactForm from "../ContactForm";
import { FaClock, FaPhoneAlt, FaCheck } from "react-icons/fa";
import { GrLocation } from "react-icons/gr";
import { IoMdMail } from "react-icons/io";

import "./index.css";

class ContactUs extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>
            Contact Us | Dependable Trash Pickup Service for Apartment Complexes
            in Peroia, IL
          </title>
          <meta
            name="description"
            content="Offering dependable trash pickup services for apartment communities in Peoria, IL, and nearby cities. Let us handle your waste management with ease!"
          />
          <link
            rel="canonical"
            href="https://simpletrashsolutionsllc.com/contact-us"
          />
        </Helmet>
        <NavBar />
        <div className="contact-us-main-container">
          <div className="banner-container">
            <div className="banner-overlay">
              <div className="banner-content">
                <h1>
                  Enhance Your Apartment Complex with Our Trash Valet Collection
                  Service.
                </h1>
                <p>
                  Ready to offer your tenants a premium, hassle-free experience?
                </p>
              </div>
            </div>
          </div>
          <div className="contact-container">
            <h1 className="heading">Contact US</h1>
            <div className="contact-main-container">
              <div className="why-choose-us-container">
                <h1>Why Choose Us</h1>
                <ul className="why-to-chooseus-list">
                  <li>
                    <div>
                      <FaCheck className="list-icon" />
                      <p>Professional and reliable service</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <FaCheck className="list-icon" />
                      <p>Flexible scheduling options</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <FaCheck className="list-icon" />
                      <p>Competitive pricing</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <FaCheck className="list-icon" />
                      <p>Experienced team</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <FaCheck className="list-icon" />
                      <p>Helping the community with 10% revenue donation</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="contact-info-container">
                <div className="card-aligment-container">
                  <div className="contact-card">
                    <FaPhoneAlt className="contact-icons" />
                    <div className="card-content">
                      <h1>Call Us</h1>
                      <p>309-643-7152</p>
                    </div>
                  </div>
                  <div className="contact-card">
                    <IoMdMail className="contact-icons" />
                    <div className="card-content">
                      <h1>Email</h1>
                      <p>ssmothers@simpletrashsolutionsllc.com</p>
                    </div>
                  </div>
                </div>
                <div className="card-aligment-container">
                  <div className="contact-card">
                    <GrLocation className="contact-icons" />
                    <div className="card-content">
                      <h1>Address</h1>
                      <p>1929 East Princeton St Peoria, IL</p>
                    </div>
                  </div>
                  <div className="contact-card">
                    <FaClock className="contact-icons" />
                    <div className="card-content">
                      <h1>Timing</h1>
                      <p>Monday - Friday</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-main-container">
          <p className="form-para">
            At Simple Trash Solutions, we are committed to providing exceptional
            local trash pickup service tailored to your needs. Whether you have
            a question about our affordable trash removal or door-to-door trash
            pickup service, we are here to help. Please fill out the form below,
            and a member of our team will get back to you promptly.
          </p>
          <ContactForm />
        </div>
        <Footer />
      </>
    );
  }
}

export default ContactUs;
